import React, { useEffect, useState } from 'react';
import {
    Grid,
    Typography,
    FormControlLabel,
    Checkbox,
    Chip,
    CircularProgress,
    Box
} from '@mui/material';
import { get } from '../utils/networkUtils';

export default function UserLevelSelector({
    selectedUserLevels = [],
    onUserLevelChange,
    title = "User Levels:",
    // Optional prop to get user levels from external source (for backward compatibility)
    userLevelStats: externalUserLevelStats
}) {
    const [userLevelStats, setUserLevelStats] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // If external userLevelStats are provided, use them
        if (externalUserLevelStats && externalUserLevelStats.length > 0) {
            setUserLevelStats(externalUserLevelStats);
        } else {
            // Otherwise, fetch them internally
            setLoading(true);
            get(`/admin/user-level`).then((response) => {
                setUserLevelStats(response.levels);
                setLoading(false);
            }).catch(() => {
                setLoading(false);
            });
        }
    }, [externalUserLevelStats]);

    const handleLevelChange = (userValueLevelId, checked) => {
        if (onUserLevelChange) {
            onUserLevelChange(userValueLevelId, checked);
        }
    };

    if (loading) {
        return (
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                    <CircularProgress size={24} />
                </Box>
            </Grid>
        );
    }

    return (
        <Grid item xs={12}>
            <Typography variant="h6" sx={{ mt: 2 }}>
                {title}
            </Typography>
            <Grid container spacing={2}>
                {userLevelStats.map((level) => (
                    <Grid item xs={2} key={level.id}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={selectedUserLevels?.includes(level.userValueLevelId.toString())}
                                    onChange={(e) => handleLevelChange(level.userValueLevelId, e.target.checked)}
                                />
                            }
                            label={
                                <Chip
                                    label={level.name}
                                    sx={{
                                        backgroundColor: level.color || '#ccc',
                                        minWidth: 70
                                    }}
                                />
                            }
                        />
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
}
